<template>
    <div class="modal bd-example-modal-lg fade show" tabindex="-1" role="dialog" aria-hidden="true" style="display: block; opacity: 1">
        <div class="modal-dialog modal-dialog-centered modal-queue-details" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        <strong>
                            "{{ job['queue'] }}"
                        </strong> - failed job
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onClose">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col">
                            <strong>Connection: </strong> {{job.connection}}
                            <hr>
                            <strong>Failed time: </strong> {{job.failed_at | dateTime}}
                            <hr>
                            <strong>Job id: </strong> {{job.id}}
                            <hr>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <strong>Exception text:</strong>
                            <pre class="job-exception mt-2">{{ exceptionText }}</pre>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success btn-sm" @click="retryJob" v-if="$isAdmin()">Push back to the queue</button>
                    <button class="btn btn-danger btn-sm" @click="removeJob" v-if="$isAdmin()">Remove from failed jobs</button>
                    <button type="button" class="btn btn-secondary btn-sm" @click="onClose">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SocketService from './../../services/socket.service';
    import moment from 'moment';
    import modalMixin from '../common/modal-mixin';

    export default {
        name: 'detailsModal',
        mixins: [modalMixin],
        props: {
            job: {
                default: false
            }
        },

        data: function () {
            return {
                queueInfo: null
            }
        },

        methods: {
            getScoreAsDate(score){
                let time = moment.unix(score);
                return time.format("YYYY-MM-DD HH:mm:ss");
            },
            retryJob(){
                Vue.block();
                this.$jobsService.retryJob(this.job.id).then(() => {
                    this.$emit('modalClosed', { removeFromListing: true });
                    Vue.unblock();
                });
            },
            removeJob(){
                Vue.block();
                this.$jobsService.removeJob(this.job.id).then(() => {
                    this.$emit('modalClosed', { removeFromListing: true });
                    Vue.unblock();
                }).catch(Vue.unblock);
            }
        },

        computed:{
            exceptionText(){
                let exeption = this.job ? this.job.exception.trim() : '';
                return exeption;
            }
        },
        watch: { }
    }

</script>

<style scope>
    .job-exception{
        font-size: 10px;
    }
    .modal-dialog.modal-queue-details{
        width: 1200px;
        max-width: 90%;
    }
    .reserved-job-row td{
        background: #97e090;
    }
</style>


// WEBPACK FOOTER //
// src/components/failed-jobs/jobDetails.modal.vue